import { UserFormRow } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';

export const WrapperUserForm = styled.form``;

const userFormSectionStyles = css`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  margin: 36px 0 0;
  max-width: 100%;
  &:first-of-type {
    margin-top: 3px;
  }
`;

export const UserFormSection = styled.div`
  ${userFormSectionStyles};
  ${UserFormRow} {
    margin-top: 30px;
    align-items: flex-start;
  }
`;
